import moment from "moment";

const knownFormats = {
    ru: {
        LYY: "DD.MM.YY"
    },
    en: {
        LYY: "MM/DD/YY"
    }
};

export default {
    formatDate(value, format) {
        if (value) {
            let usedFormat = format;
            if (knownFormats[window.AcademIt.Locale][format]) {
                usedFormat = knownFormats[window.AcademIt.Locale][format];
            }

            return moment(value).format(usedFormat || "L");
        }

        return value;
    },

    formatDateTime(value, format) {
        if (value) {
            let usedFormat = format;
            if (knownFormats[window.AcademIt.Locale][format]) {
                usedFormat = knownFormats[window.AcademIt.Locale][format];
            }

            return moment(value).format(usedFormat || "L LT");
        }

        return value;
    }
};